import generateActions from 'utils/actions';
import Post from 'store/models/post';

export const GET_BLOG = generateActions('blog/GET_BLOG');
export const GET_POST = generateActions('blog/GET_POST');
export const GET_FEATURED = generateActions('blog/GET_FEATURED');

/**
 * Return a list of latest published blog posts
 */
export function loadBlog(params) {
  return {
    types: GET_BLOG,
    promise: {
      url: '/blog',
      reader: {
        model: Post,
        root: 'blog',
      },
      data: {
        page: 0,
        ...params,
      },
    },
  };
}

/**
 * Load all featured posts
 * @param {Params} params 
 */
export function loadFeatured(params) {
  return {
    types: GET_FEATURED,
    promise: {
      url: '/blog/featured',
      reader: {
        model: Post,
        root: 'featured',
      },
      data: {
        page: 0,
        ...params,
      },
    },
  };
}

/**
 * Load a post by ID
 */
export function loadPost(id) {
  return {
    types: GET_POST,
    promise: {
      url: `/blog/${id}`,
      reader: {
        model: Post,
        root: 'blog',
      },
    },
  };
}
